/**
 * @fileoverview TanStack Router root route configuration.
 *
 * Defines the root route for the application and delegates layout responsibilities
 * to the RootLayout component following separation of concerns.
 */

import { createRootRoute } from '@tanstack/react-router';
import { RootLayout } from '../components/RootLayout';

/**
 * TanStack Router root route configuration.
 * Defines the base route for the application with the root layout component.
 */
export const Route = createRootRoute({
  component: RootLayout,
});
